import React from 'react'
import { StaticImage } from 'gatsby-plugin-image'
import * as styles from './LogoCarousel.module.scss'

const Row2: React.FC = () => {
  return (
    <>
      <div className={styles.slide}>
        <StaticImage
          width={80} height={80}
          src='./assets/logo4.png' className={styles.image} alt=''
        />
      </div>
      <div className={styles.slide}>
        <StaticImage
          width={80} height={80}
          src='./assets/logo10.png' className={styles.image} alt=''
        />
      </div>
      <div className={styles.slide}>
        <StaticImage
          width={80} height={80}
          src='./assets/logo1.png' className={styles.image} alt=''
        />
      </div>
      <div className={styles.slide}>
        <StaticImage
          width={80} height={80}
          src='./assets/logo12.png' className={styles.image} alt=''
        />
      </div>
      <div className={styles.slide}>
        <StaticImage
          width={80} height={80}
          src='./assets/logo14.png' className={styles.image} alt=''
        />
      </div>
      <div className={styles.slide}>
        <StaticImage
          width={80} height={80}
          src='./assets/logo17.png' className={styles.image} alt=''
        />
      </div>
      <div className={styles.slide}>
        <StaticImage
          width={80} height={80}
          src='./assets/logo13.png' className={styles.image} alt=''
        />
      </div>
      <div className={styles.slide}>
        <StaticImage
          width={80} height={80}
          src='./assets/logo16.png' className={styles.image} alt=''
        />
      </div>
      <div className={styles.slide}>
        <StaticImage
          width={80} height={80}
          src='./assets/logo15.png' className={styles.image} alt=''
        />
      </div>
    </>
  )
}

export default Row2
